import {tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class GetNewsUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.getNewsService
   */
  constructor({repository, paginationRepository}) {
    super()
    this._repository = repository
    this._paginationRepository = paginationRepository
  }

  /**
   * @return {Promise<Object, Error>} returns array with feed arrays of news
   * @property {Array} news items
   */
  @tracer({metric: 'GetNewsUseCase#execute'})
  execute({category = '', count = 20, makeId, modelId, page = 1, searchTerm = '', section, tag = '', year} = {}) {
    return this._repository
      .getNews({
        category,
        count,
        makeId,
        modelId,
        page,
        searchTerm,
        section,
        tag,
        year
      })
      .then(searchNewsVo => {
        return this._paginationRepository
          .getPagination({
            category,
            page,
            searchNewsVo,
            searchTerm,
            section,
            tag
          })
          .then(paginationVo => {
            searchNewsVo.setPagination(paginationVo)

            return searchNewsVo
          })
      })
      .then(result => result.toJSON())
  }
}
